'use strict';

var Backbone = require('backbone');
var _ = require('underscore');
var moment = require('moment-timezone');

var DayView = require('./day').default;

export default Backbone.View.extend({

  tagName: 'tr',
  className: 'date-picker-week',

  initialize: function (options) {
    this.start = options.start;
    this.min = options.min;
    this.max = options.max || null;
    this.current = options.current;
    this.length = options.length;
    this.month = options.month;
    this.collection = options.collection || {};
  },

  render: function () {
    this.$el.empty();
    _.each(this.getDays(), _.bind(this.renderDay, this));
    return this;
  },

  getDays: function () {
    var days = [],
      day = this.start.clone(),
      endOfWeek = this.start.clone().endOf('week');
    let dayCollection = {};

    while (day.isBefore(endOfWeek)) {
      dayCollection = this.filterDayCollection(this.collection, day);

      days.push(new DayView({
        start: day.clone(),
        min: this.min.clone(),
        max: this.max ? this.max.clone() : null,
        current: this.current.clone(),
        length: this.length,
        month: this.month.clone(),
        collection: dayCollection || {},
      }));

      day.add(1, 'day');
    }

    return days;
  },

  filterDayCollection: function (collection, day) {
    return collection.find(timeslot => moment(timeslot.attributes.value)
      .isSame(day.clone().format('YYYY-MM-DD'), 'day'));
  },

  renderDay: function (day) {
    this.$el.append(day.render().el);
  },

});
